import { render, staticRenderFns } from "./RevenueInfo.vue?vue&type=template&id=5aa37c9e&scoped=true&"
import script from "./RevenueInfo.vue?vue&type=script&lang=js&"
export * from "./RevenueInfo.vue?vue&type=script&lang=js&"
import style0 from "./RevenueInfo.vue?vue&type=style&index=0&id=5aa37c9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa37c9e",
  null
  
)

export default component.exports